var React = require('react');

function Ap (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-type":"bg","fill":"#FFF","d":"M0 78h75V.2H0z","key":0}),React.createElement("path",{"fill":"#FF322E","d":"M0 78h75v9.1H0V78","key":1}),React.createElement("path",{"fill":"#000","d":"M17.3 20.7L4.7 58.5h9.1l8.5-26.7 4.3 13.3h-5.5l-2.2 7.7h10.2l1.8 5.7h9.4L27.7 20.7H17.3M54.7 20.7H41.6v37.8h9V28.3h3.7c4.2 0 6.6 2 6.6 5.7 0 3.6-2.4 5.7-6.6 5.7h-.6v7.6h1c9.7 0 15.5-5 15.5-13.3 0-8.5-5.8-13.3-15.5-13.3","key":2})]);
}

Ap.defaultProps = {"width":"75","height":"88","viewBox":"0 0 75 88"};

module.exports = Ap;

Ap.default = Ap;
